import { lazy } from 'react';

const RELOAD_FLAG = 'panel-seguros:chunk-reload';
const RELOAD_COOLDOWN_MS = 60_000;

function isChunkLoadError(error) {
  if (!error) return false;
  if (error.name === 'ChunkLoadError') return true;
  const message = String(error.message ?? '');
  return (
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Loading chunk \S+ failed/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /error loading dynamically imported module/i.test(message)
  );
}

function getReloadTimestamp() {
  try {
    return Number(sessionStorage.getItem(RELOAD_FLAG) ?? 0);
  } catch {
    return 0;
  }
}

function setReloadTimestamp(value) {
  try {
    sessionStorage.setItem(RELOAD_FLAG, String(value));
  } catch {
    // sessionStorage puede no estar disponible (modo privado, SSR, etc.)
  }
}

function triggerReload() {
  setReloadTimestamp(Date.now());
  window.location.reload();
}

export function lazyWithRetry(loader, retries = 1) {
  return lazy(() =>
    loader().catch(error => {
      if (!isChunkLoadError(error)) {
        throw error;
      }

      if (retries <= 0) {
        throw error;
      }

      const lastReload = getReloadTimestamp();
      const now = Date.now();
      const recentlyReloaded = now - lastReload < RELOAD_COOLDOWN_MS;

      if (recentlyReloaded) {
        throw error;
      }

      triggerReload();
      return new Promise(() => {});
    })
  );
}
